import { useEffect, useState } from "react";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import { useSetRecoilState } from "recoil";

import "react-reflex/styles.css";

import layoutConf from "../../config/layoutConf";
import notificationState from "../../states/notificationState";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import VwMsgSent from "./VwMsgSent";
import Message from "./Message";

import ConfirmDialog from "../dialogTypes/ConfirmDialog";
import apiClient from "../../lib/common/apiClient";

function MsgSent ( props ) {

    const { t } = useTranslation();

    const [ msg, setMsg ] = useState ( );
    const [ height, setHeight ] = useState(0);
    const [ disabled, setDisabled ] = useState(false);

    const [ , setApi ] = useState ( );
    const [ , setGrid ] = useState ( );
    const [ , setSelection ] = useState( "" );
    const [ , setConfirmDialog ] = useState( );

    const [ confirmTitle, setConfirmTitle ] = useState( "" );
    const [ confirmMsg, setConfirmMsg ] = useState( "" );
    const [ action, setAction ] = useState({
        operation: undefined, // "markReadAll", "markUnread", "delete"
        data: undefined
    } );

    const setNotification = useSetRecoilState(notificationState);

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    const onSelectMsg = ( selection, grid ) => {

        if ( selection.length > 0 ) {

            setDisabled ( false );

        } else {

            setDisabled ( true );

        }

        if ( selection && selection[0] ) {

            setMsg ( selection[0] );

        } else {

            setMsg ( undefined );

        }

        setSelection ( selection );

    };

    const onGridInitialized = ( grid ) => {

        setGrid ( grid );

    };

    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const onConfirmDialogInitialized = ( dialog ) => {

        setConfirmDialog ( dialog );

    };

    const moveToTrash = ( selection ) => {

        apiClient.put ( `api/SentMsg/moveToTrash`, selection )
            .then ( ( result ) => {

                    setApi ( ( api ) => {

                        if ( api ) {
                            
                            api.refresh ( false );
        
                        }

                        return api;

                    } );

                    notifySuccess ( t ( "success.moveToTrashSuccess" ) );

                } )
                .catch ( ( reason ) => {

                    notifyFailure  ( t ( "error.moveToTrashFailed" ) );

                } );

    };

    const onDelete = ( selection ) => {

        setSelection ( ( selection ) => {

            setAction ( {
                operation: "delete",
                data: selection
            } );

            setConfirmTitle ( t("dialog.title.Message.confirm.moveToTrash") );
            setConfirmMsg ( t ("dialog.msg.Message.confirm.moveToTrash") );
            setConfirmDialog ( ( dialog ) => {
                
                dialog.show ();
                return dialog;

            } );

            return selection;

        } );

    };

    const onConfirmed = ( action ) => {

        if ( action ) {

            switch ( action.operation ) {

                case "delete":

                    moveToTrash ( action.data );
                    break;

                default:

                    notifyFailure ( t ( "error.unknownOperation" ) );
                    break;

            }

        }

    };

    return (

        <div style={{ height: height } }>

            <ReflexContainer orientation="horizontal">

                <ReflexElement flex={ 0.5 } >

                    <VwMsgSent

                        headerTitle={ t ( "term.msgList" ) }

                        noCreate
                        noEdit
                        noDelete
                        noExcel

                        onAppendButtonInFrontOfSearch = {

                            ( ) => (

                                <BasicCrudScreenActionItemLayout>

                                    <Button color="secondary" disabled={disabled} onClick={ onDelete }>{ t ( "buttonName.delete" ) }</Button>

                                </BasicCrudScreenActionItemLayout>

                            )

                        }

                        onSelect={ onSelectMsg }
                        onInitialized={ onGridInitialized }
                        onApiInitialized={ onApiInitialized }

                    />

                </ReflexElement>

                <ReflexSplitter
                    style={{ height: layoutConf.reflex.splitterHeight }}
                />

                <ReflexElement>

                    <Message msg={ msg } />

                </ReflexElement>

            </ReflexContainer>

            <ConfirmDialog

                id={"inbox-confirm-dialog"}
                title={ confirmTitle }
                msg={ confirmMsg }
                data={ action }
                onOk={ ( action ) => onConfirmed ( action ) }
                onInitialized={ onConfirmDialogInitialized }

            />

        </div>

    );
}

export default MsgSent;

